import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse, Institution } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const INSTITUTION_URL = '/ris/institutions/v1';

interface ParamsGetInstitution {
  ids?: string[];
  code?: string;
  limit?: number;
  offset?: number;
  sort_field?: '' | 'code' | 'name' | 'created_at' | 'updated_at';
  sort_order?: SORT_ORDER;
}
export interface ResponseGetInstitution extends DefaultResponse {
  data: Institution[];
}
export const getInstitutions = async (
  params: ParamsGetInstitution = {
    limit: 100,
    offset: 0,
  }
) => {
  const response = await api({
    url: INSTITUTION_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  }) as AxiosResponse<ResponseGetInstitution>;

  return response.data;
};
export interface ResponseGetDetailInstitution extends DefaultResponse {
  data: Institution;
}
export const getDetailInstitution = async (id: string) => {
  const response = await api({
    url: `${INSTITUTION_URL}/${id}`,
    method: 'GET',
  }) as AxiosResponse<ResponseGetDetailInstitution>;

  return response.data;
};

export interface ParamsCreateInstitution {
  address: string;
  code: string;
  email: string;
  logo: string;
  name: string;
  phone: string;
}
export const createInstitution = async (data: ParamsCreateInstitution) => {
  const response = await api({
    url: INSTITUTION_URL,
    method: 'POST',
    data,
  }) as AxiosResponse<any>;

  return response.data;
};
export const createSSOInstitution = async (data: ParamsCreateInstitution) => {
  const response = await api({
    url: `${INSTITUTION_URL}/sso`,
    method: 'POST',
    data,
  }) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateInstitution {
  address: string;
  email: string;
  logo: string;
  name: string;
  phone: string;
}
export const updateInstitution = async (id: string, data: ParamsUpdateInstitution) => {
  const response = await api({
    url: `${INSTITUTION_URL}/${id}`,
    method: 'PUT',
    data,
  }) as AxiosResponse<any>;

  return response.data;
};

export const deleteInstitution = async (id: string) => {
  const response = await api({
    url: `${INSTITUTION_URL}/${id}`,
    method: 'DELETE',
  }) as AxiosResponse<any>;

  return response;
};
